exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!./css/320.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!./css/375.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!./css/425.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!./css/768.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!./css/1024.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!./css/1440.css"), "");

// module
exports.push([module.id, "#page {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    overflow: none;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/claudio/Projects/thebatclaudio.github.io/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main